import type { RouteLocationNormalized, RouteMeta } from 'vue-router'

export const setPageHeader = (route: RouteLocationNormalized, header: RouteMeta['header']) => {
  const nuxtApp = useNuxtApp()

  route.meta.header = {
    ...route.meta.header,
    ...header
  }

  nuxtApp.callHook('header:update')
}
